import {Component, computed, effect, input, model, viewChildren, WritableSignal} from '@angular/core'
import {TaxationTinComponent} from '../../../../form/00-pure/54-taxation-tin/taxation-tin.component'
import {CountrySelectComponent} from '../../../../form/00-pure/28a-country/country-select.component'
import {BaseComponent} from '../../../../form/00-pure/base.component'

export interface ITaxationModel {
  country: WritableSignal<string>
  tin: WritableSignal<string | null>
}

@Component({
  selector: 'spb-country',
  imports: [
    TaxationTinComponent,
    CountrySelectComponent
  ],
  templateUrl: './taxation-country.component.html',
  styleUrl: './taxation-country.component.scss'
})
export class TaxationCountryComponent {
  public input = model.required<ITaxationModel>()

  public valid = computed(() => this.children().every(c => c.valid()))

  public excluded = input<string[]>([])
  private readonly children = viewChildren(BaseComponent)

  constructor() {
    effect(() => {
      if (this.input().country() === 'SE') {
        this.input().tin.set(null)
      }
    })
  }
}

